import React, { useEffect, useState } from 'react';

import { useDispatch, useSelector, useStore } from 'react-redux';

import { emptyObject } from 'ui-components/default-props/empty';
import { useFulfillmentPlanIdContext } from '../../../../fulfillment-plans/context/fulfillment-plan-id-context-provider';
import { ChildrenPropType } from '../../../../prop-types/children';
import Global from '../../../../store/global-selectors';
import { setSelectedShipments } from '../../../../store/shipments/selected-shipments/shipments.selected-shipments.actions';
import { getPreviousAndNextShipmentsGridIds } from '../../../../store/shipments/shipments.helpers';
import { useSalesOrderIdContext } from '../../../context/sales-order-id-context-provider';
import { defaultOrderDetailsNavigationContext, OrderDetailsNavigationContext } from './order-details-navigation-context';

const ShipmentsPageNavigationContextProvider = ({ children }) => {
  const [value, setValue] = useState(defaultOrderDetailsNavigationContext);
  const isGridLoading = useSelector(Global.selectShipmentsGridIsLoading);
  const salesOrderId = useSalesOrderIdContext();
  const fulfillmentPlanId = useFulfillmentPlanIdContext();

  const dispatch = useDispatch();
  const { getState } = useStore();

  useEffect(() => {
    if (isGridLoading) {
      return;
    }

    const state = getState();
    const fulfillmentIdsInGrid = Global.selectShipmentsGridCurrentPageFulfillmentIds(state);
    const fulfillmentPlanIdsInGrid = Global.selectEntitiesFPIdsByFulfillmentIds(state, { fulfillmentIds: fulfillmentIdsInGrid });
    const fulfillmentPlansInGrid = Global.selectEntitiesFulfillmentPlansByIds(state, {
      fulfillmentPlanIds: fulfillmentPlanIdsInGrid,
    }).filter((record) => record?.salesOrdersFulfilledIds?.length > 0);

    setValue(getPreviousAndNextShipmentsGridIds(fulfillmentPlansInGrid, fulfillmentPlanId, salesOrderId));

    if (fulfillmentPlanIdsInGrid?.includes(fulfillmentPlanId)) {
      const fulfillments = Global.selectEntitiesFulfillmentsByFulfillmentPlanId(state, { fulfillmentPlanId });
      const { fulfillmentId } = fulfillments[0] ?? emptyObject;
      if (fulfillmentId) {
        dispatch(setSelectedShipments([fulfillmentId]));
      }
    }
  }, [dispatch, fulfillmentPlanId, getState, isGridLoading, salesOrderId]);

  return <OrderDetailsNavigationContext.Provider value={value}>{children}</OrderDetailsNavigationContext.Provider>;
};

export default ShipmentsPageNavigationContextProvider;

ShipmentsPageNavigationContextProvider.propTypes = {
  children: ChildrenPropType.isRequired,
};
